// extracted by mini-css-extract-plugin
export var parcelRow = "_to-0";